<h3
  i18n="PCard|Similar products header text@@pcardSimimlarProdcutsHeaderText"
  class="text-center my-1"
>
  Similar products
</h3>

@if (isLoading()) {
<atx-loader-overlay
  i18n-loaderText="Pcard|Similar products loading@@loadingSimilarProducts"
  loaderText="Loading products..."
  type="static"
  class="overlay"
></atx-loader-overlay>
} @else if (hasError()) {
<span
  i18n="PCard|Load similar error text@@similarProductsError"
  class="text-danger font-size-lg font-weight-bold m-auto"
>
  An unexpected error occurred.
</span>
} @else if (products()?.length > 0) {
<div class="products_wrapper">
  @for (product of products(); track product.productId) {
  <atx-horizontal-product-v2
    [product]="product"
    (click)="onProductClick(product)"
  ></atx-horizontal-product-v2>
  }
</div>

} @else if (isLoaded()) {
<span
  i18n="PCard|Load similar no products text@@pcardSimilarNoProductsText"
  class="font-size-lg font-weight-bold m-auto"
>
  No available products
</span>
}
